import React from 'react';

const Facebook = () => {
  return <i className="fa fa-facebook-square" aria-hidden="true" />;
};

const Instagram = () => {
  return <i className="fa fa-instagram" aria-hidden="true" />;
};

const Pinterest = () => {
  return <i className="fa fa-pinterest-square" aria-hidden="true" />;
};

const Youtube = () => {
  return <i className="fa fa-youtube-play" aria-hidden="true" />;
};

export default {
  Facebook,
  Instagram,
  Pinterest,
  Youtube
};



// WEBPACK FOOTER //
// ./src/components/SocialLink.js